import { call, put, takeLatest } from 'redux-saga/effects'
import { GET_SESSIONS } from '../App/constants'
import { getSessionsSuccess, getSessionsError } from '../App/actions'
import request from '../../utils/request'

const tgdApiPath = process.env.REACT_APP_TGDAPI_SERVER || ''

export function * fetchSessions ({ token }) {
  const url = `${tgdApiPath}/sessions`
  try {
    const data = yield call(request, url, {
      method: 'GET',
      headers: { 'Authorization': `Bearer ${token}` },
    })
    const sessions = Array.isArray(data) ? data : (data.data || [])
    yield put(getSessionsSuccess(sessions))
  } catch (err) {
    yield put(getSessionsError(err))
  }
}

export function * getSessionsSaga () {
  yield takeLatest(GET_SESSIONS, fetchSessions)
}
